import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-add-edit__form--header h-flex h-flex-center h-flex-space-between" }
const _hoisted_2 = { style: {"text-align":"left","width":"100%"} }
const _hoisted_3 = { class: "h-font-16 h-m-0" }
const _hoisted_4 = { style: {"text-align":"right","width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FwButton, {
      color: "transparent",
      style: {"color":"#D71254","min-width":"100px"},
      fontSize: "12px",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("previousComponent")))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.backButton)), 1)
      ]),
      _: 1
    }),
    _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t(_ctx.title)), 1),
    _createVNode(_component_FwButton, {
      color: "transparent",
      fontSize: "12px",
      style: {"min-width":"100px","text-align":"right"},
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit("confirmEvent")))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t(_ctx.confirmButton)), 1)
      ]),
      _: 1
    })
  ]))
}